export enum Priority {
    Normal = 'normal',
    High = 'high',
}